import {
	SimpleForm, SaveButton,
	TextInput, Title, Toolbar,
	useGetIdentity, useTranslate, useGetOne, useUpdate, useNotify, useRedirect,
} from 'react-admin';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent } from '@mui/material';

export const ProfileEdit = () => {
	const translate = useTranslate();
	const { identity, isLoading } = useGetIdentity();
	const redirect = useRedirect();
	const notify = useNotify();
	
	const pageTitle = translate('profile.title');
	const systemName = translate('system.name');
	
	if (isLoading) return <p>読込中です。</p>;
	if (!identity) return <p>エラーが発生しました。</p>;

	return <ProfileEditForm identity={identity} pageTitle={pageTitle} systemName={systemName} redirect={redirect} notify={notify} />;
};

const ProfileToolbar = ({ isUpdating }: { isUpdating: boolean }) => (
	<Toolbar>
		<SaveButton alwaysEnable disabled={isUpdating} />
	</Toolbar>
);

const ProfileEditForm = ({ identity, pageTitle, systemName, redirect, notify }: any) => {
	const translate = useTranslate();
	const { data: record, isLoading, error } = useGetOne('manager', { id: identity.id }, { meta: { mode: 'kanri' } });
	const [update, { isLoading: isUpdating }] = useUpdate();

	const handleSave = (values: any) => {
		update(
			'manager',
			{ id: identity.id, data: values, meta: { mode: 'kanri' } },
			{
				onSuccess: () => {
					notify('プロフィールを更新しました。', { type: 'success' });
					redirect('/');
				},
				onError: (error) => {
					notify(`エラー: ${error.message}`, { type: 'error' });
				}
			}
		);
	};
	
	if (isLoading) return <p>読込中です。</p>;
	if (error) return <p>エラーが発生しました。</p>;
	if (!record) return null;
	
	return(
		<Card>
			<Helmet>
				<title>{`${pageTitle} | ${systemName}`}</title>
			</Helmet>
			<Title title={pageTitle} />
			<CardContent>
				<SimpleForm record={record} onSubmit={handleSave} toolbar={<ProfileToolbar isUpdating={isUpdating} />}>
					<TextInput source="id" label={translate('profile.id')} disabled />
					<TextInput source="name" label={translate('profile.name')} />
					<TextInput source="kana" label={translate('profile.kana')} />
					<TextInput source="loginid" label={translate('profile.loginid')} disabled />
					<TextInput source="new_password" label={translate('profile.new_password')} />
					<TextInput source="role" label={translate('profile.role')} disabled />
				</SimpleForm>
			</CardContent>
		</Card>
	)
}

export default ProfileEdit;